// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"664a0bb6","418":"74fd26a6","787":"0c9cf7e8"}[chunkId] + ".chunk.js";
};